var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-spin",
    { attrs: { spinning: _vm.isLoading } },
    [
      _c(
        "a-select",
        {
          on: { change: _vm.onChange },
          model: {
            value: _vm.selectedId,
            callback: function ($$v) {
              _vm.selectedId = $$v
            },
            expression: "selectedId",
          },
        },
        [
          _c("a-select-option", { attrs: { value: -1 } }, [_vm._v("热门")]),
          _vm._v(" "),
          _vm._l(_vm.categoryList, function (item, index) {
            return _c(
              "a-select-option",
              { key: index, attrs: { value: item.category_id } },
              [_vm._v(_vm._s(item.name))]
            )
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }